"use strict";

var moment = require('moment');
/**
 * takeInventory
 * @param {Array<PrintJob>} printJobsArray
 * @param {*} options - ShinePrintingConfig
 * @example
[
    {
        name: 'Vellum Jackets',
        key: 'vellum_jackets',
        unit: 'each',
        category: ''
        date: <ISODateString>,
        total: 200,
    },
    {
        name: 'Fog Ribbon Spools',
        key: 'fog_ribbon_spools',
        unit: 'each',
        category: ''
        date: <ISODateString>,
        total: 20,
    },
    {
        name: 'Shine Pearl 107lb Cover',
        key: 'shine_pearl_107lb_cover',
        unit: 'sheet',
        category: ''
        date: <ISODateString>,
        total: 2032,
    },
]
*/


var flattenDeep = require('lodash/flattenDeep');

var inventoryWaxSeals = require('./inventoryWaxSeals');

var inventoryVellumJackets = require('./inventoryVellumJackets');

var inventoryRibbonSpools = require('./inventoryRibbonSpools');

var inventoryPaperComponents = require('./inventoryPaperComponents');

var inventoryEnvelopes = require('./inventoryEnvelopes');

var inventoryGlueDots = require('./inventoryGlueDots'); // const isLetterpressComponent = require('./isLetterpressComponent');


function takeInventory(printJobsArray, options) {
  var inventory = flattenDeep(printJobsArray.map(function (printJob) {
    var date = moment(printJob.print_by_date).toISOString();
    var printerName = printJob.printer_name;
    var arr = [];

    try {
      arr = printJob.products.map(function (product) {
        var subcomponents = product.subcomponents(); // .filter(filterer);

        return [inventoryWaxSeals, inventoryVellumJackets, inventoryRibbonSpools, inventoryGlueDots, inventoryPaperComponents, inventoryEnvelopes].map(function (f) {
          return f(subcomponents, date, options, printerName);
        });
      });
    } catch (error) {
      console.log();
      console.log(printJob);
      console.log();
      console.error(error);
    }

    return arr;
  }));
  return inventory;
}

module.exports = takeInventory;